import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import * as Type from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as CarTypeFilterStyles from "../car-type/styles/CarTypeFilterStyles";
import * as FilterCheckInputStyles from "../../common/styles/FilterCheckInputStyles";

export const ListItem = styled.div``;

export const Wrapper = styled.details<{ isActive?: boolean }>`
    position: relative;
    width: 100%;
    height: minmax(63px, min-content);
    background: ${theme.colors.steel};

    @media ${getBreakpoint("up", "lg")} {
        width: 100%;
    }
`;

export const DropdownContent = styled.div<{ show?: boolean }>`
    margin: 0;
    padding: 0 ${theme.space[3]}px ${theme.space[2]}px;
    background-color: ${theme.colors.steel};
    border-bottom: 1px solid ${({ show }) => (show ? theme.colors.brushedSteel : "transparent")};

    /* Set light variant from components */
    ${CarTypeFilterStyles.Label} {
        color: ${theme.colors.white};
    }
    ${FilterCheckInputStyles.Checkbox} {
        color: ${theme.colors.white};
    }
`;

export const Header = styled.summary<{ show?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.space[2]}px ${theme.space[3]}px;
    color: ${theme.colors.white};
    background: ${({ show }) => (show ? theme.colors.steel : theme.colors.steel)};
    border-bottom: 1px solid ${({ show }) => (show ? "transparent" : theme.colors.brushedSteel)};
    cursor: pointer;

    ${Type.Text} {
        margin-bottom: 0;
        font-size: 1.4rem;
        line-height: 1.9rem;
    }

    ${IconWrapper} {
        transform: ${({ show }) => (show ? "rotate(45deg)" : "none")};
        transition: transform 0.3s;
    }
`;
